export default "/assets/images/technology-graph-02.5eba5e7ca58b8266.png";